import Vue from 'vue';
import VueRouter, { Route, RouteConfig } from 'vue-router';
import client from 'baimahu/client';
import storage from 'baimahu/storage';
import { hundun_route_type } from '@/common/enum';
const { VUE_APP_FCAPI: FCAPI, VUE_APP_EXPIRED: EXPIRED, VUE_APP_OA: OA, VUE_APP_XDB: XDB, VUE_APP_STAGE: STAGE } = process.env;

const API = {
  product_menu: `${FCAPI}/boss/setting/auth/product/menu`
};

Vue.use(VueRouter);
const limit_route: Array<RouteConfig> = [
  {
    path: '/limit/index',
    meta: { layout: 'IndexLayout', number: 2 },
    name: '权限管理',
    component: () => import(/* webpackChunkName: "limit" */ '@/view/limit/index/main.vue')
  },
  {
    path: '/limit/mangement-account',
    meta: { layout: 'IndexLayout' },
    name: '权限列表',
    component: () => import(/* webpackChunkName: "limit" */ '@/view/limit/mangement-account/main.vue')
  },
  {
    path: '/limit/edit-account',
    meta: { layout: 'IndexLayout' },
    name: '编辑权限',
    component: () => import(/* webpackChunkName: "limit" */ '@/view/limit/edit-account/main.vue')
  }
];

const hundun_route: Array<RouteConfig> = [
  {
    path: '/hundun/index',
    meta: { layout: 'IndexLayout' },
    name: '主页',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/index/main.vue')
  },
  {
    path: '/hundun/user-detail/:id',
    meta: { layout: 'IndexLayout', from: '/hundun/user-list' },
    name: '用户详情页',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/user-manage/user-detail.vue')
  },
  {
    path: '/hundun/user-list',
    meta: { layout: 'IndexLayout' },
    name: '用户管理',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/user-manage/user-list.vue')
  },
  {
    path: '/hundun/register-list',
    meta: { layout: 'IndexLayout', number: 2 },
    name: '注册列表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/work-list/register-list.vue')
  },
  {
    path: '/hundun/start-school',
    meta: { layout: 'IndexLayout', number: 2 },
    name: '入学列表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/work-list/start-school.vue')
  },
  {
    path: '/hundun/back-list',
    meta: { layout: 'IndexLayout', number: 2 },
    name: '回访列表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/work-list/back-list.vue')
  },
  {
    path: '/hundun/temporary-mission',
    meta: { layout: 'IndexLayout', number: 2 },
    name: '临时任务表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/work-list/temporary-mission.vue')
  },
  {
    path: '/hundun/mission-detail/:id',
    meta: { layout: 'IndexLayout', from: '/hundun/temporary-mission' },
    name: '任务详情表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/work-list/mission-detail.vue')
  },
  {
    path: '/hundun/cross-cooperation',
    meta: { layout: 'IndexLayout', number: 2 },
    name: '异业合作表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/work-list/cross-cooperation.vue')
  },
  {
    path: '/hundun/setting-wechat',
    meta: { layout: 'IndexLayout', number: 3 },
    name: '班主任微信管理',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/setting/setting-wechat.vue')
  },
  {
    path: '/hundun/user-tags',
    meta: { layout: 'IndexLayout', number: 3 },
    name: '学员标签管理',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/setting/tags-manage.vue')
  },
  {
    path: '/hundun/data-center/student-report',
    meta: { layout: 'IndexLayout', number: 5 },
    name: '学员统计报表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/data-center/student-report.vue')
  },
  {
    path: '/hundun/company-list',
    meta: { layout: 'IndexLayout', number: hundun_route_type.company },
    name: '企业总表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/company/company-list.vue')
  },
  {
    path: '/hundun/tub-company',
    meta: { layout: 'IndexLayout', number: hundun_route_type.company },
    name: '兔必企业',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/company/tubi-company.vue')
  },
  {
    path: '/hundun/company-detail',
    meta: { layout: 'IndexLayout', from: '/hundun/company-list' },
    name: '企业详情',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/company/company-detail.vue')
  },
  {
    path: '/hundun/tubi-visit-list',
    meta: { layout: 'IndexLayout', number: hundun_route_type.company_work },
    name: '企业回访列表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/company/tubi-visit-list.vue')
  },
  {
    path: '/hundun/company/company-intention',
    meta: { layout: 'IndexLayout', number: hundun_route_type.company_work },
    name: '企业意向列表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/company/company-intention.vue')
  },
  {
    path: '/hundun/setting-follow',
    meta: { layout: 'IndexLayout', number: 3 },
    name: '企业跟进人管理',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/setting/setting-follow.vue')
  },
  {
    path: '/hundun/chuang/seeding',
    meta: { layout: 'IndexLayout', number: 6 },
    name: '流量池',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/chuang/seeding.vue')
  },
  {
    path: '/hundun/chuang/recruition',
    meta: { layout: 'IndexLayout', number: 6 },
    name: '报名列表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/chuang/recruition.vue')
  },
  {
    path: '/hundun/chuang/delivery',
    meta: { layout: 'IndexLayout', number: 6 },
    name: '交付列表',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/chuang/delivery.vue')
  },
  {
    path: '/hundun/chuang/seeding/type',
    meta: { layout: 'IndexLayout', number: 6 },
    name: '创商跟进分类管理',
    component: () => import(/* webpackChunkName: "hundun" */ '@/view/hundun/chuang/seeding-type.vue')
  }
];
const ruan_route: Array<RouteConfig> = [
  {
    path: '/ruan/category',
    meta: { layout: 'IndexLayout' },
    name: '单品品类',
    component: () => import(/* webpackChunkName: "ruan" */ '@/view/ruan/category/main.vue')
  },
  {
    path: '/ruan/product-list',
    meta: { layout: 'IndexLayout' },
    name: '软装单品',
    component: () => import(/* webpackChunkName: "ruan" */ '@/view/ruan/product/list.vue')
  },
  {
    path: '/ruan/package-list',
    meta: { layout: 'IndexLayout' },
    name: '软装套餐',
    component: () => import(/* webpackChunkName: "ruan" */ '@/view/ruan/package/list.vue')
  },
  {
    path: '/ruan/collocation',
    meta: { layout: 'IndexLayout' },
    name: '单品套餐搭配',
    component: () => import(/* webpackChunkName: "ruan" */ '@/view/ruan/collocation/main.vue')
  },
  {
    path: '/ruan/style',
    meta: { layout: 'IndexLayout' },
    name: '风格管理',
    component: () => import(/* webpackChunkName: "ruan" */ '@/view/ruan/style/main.vue')
  },
  {
    path: '/ruan/style-list',
    meta: { layout: 'IndexLayout' },
    name: '风格案例',
    component: () => import(/* webpackChunkName: "ruan" */ '@/view/ruan/style/list.vue')
  },
  {
    path: '/ruan/community',
    meta: { layout: 'IndexLayout' },
    name: '小区管理',
    component: () => import(/* webpackChunkName: "ruan" */ '@/view/ruan/community/main.vue')
  },
  {
    path: '/ruan/sample-room-list',
    meta: { layout: 'IndexLayout' },
    name: '样板房',
    component: () => import(/* webpackChunkName: "ruan" */ '@/view/ruan/sample-room/list.vue')
  },
  {
    path: '/ruan/swiper',
    meta: { layout: 'IndexLayout' },
    name: '轮播配置',
    component: () => import(/* webpackChunkName: "ruan" */ '@/view/ruan/swiper/main.vue')
  },
  {
    path: '/ruan/active',
    meta: { layout: 'IndexLayout' },
    name: '活动页配置',
    component: () => import(/* webpackChunkName: "ruan" */ '@/view/ruan/active/main.vue')
  }
];

const ruan_route_detail: Array<RouteConfig> = [
  {
    path: '/ruan/index',
    meta: { layout: 'IndexLayout' },
    component: () => import(/* webpackChunkName: "ruan-detail" */ '@/view/ruan/index/main.vue')
  },
  {
    path: '/ruan/package-detail/:id',
    meta: { layout: 'IndexLayout' },
    name: '软装套餐',
    component: () => import(/* webpackChunkName: "ruan-detail" */ '@/view/ruan/package/detail.vue')
  },
  {
    path: '/ruan/product-detail/:id',
    meta: { layout: 'IndexLayout' },
    name: '软装单品',
    component: () => import(/* webpackChunkName: "ruan-detail" */ '@/view/ruan/product/detail.vue')
  },
  {
    path: '/ruan/sample-room-detail/:id',
    meta: { layout: 'IndexLayout' },
    name: '样板房',
    component: () => import(/* webpackChunkName: "ruan-detail" */ '@/view/ruan/sample-room/detail.vue')
  },
  {
    path: '/ruan/style-detail/:id',
    meta: { layout: 'IndexLayout' },
    name: '风格案例',
    component: () => import(/* webpackChunkName: "ruan-detail" */ '@/view/ruan/style/detail.vue')
  },
  {
    path: '/ruan/community-detail/:id',
    meta: { layout: 'IndexLayout' },
    name: '小区管理',
    component: () => import(/* webpackChunkName: "ruan-detail" */ '@/view/ruan/community/detail.vue')
  }
];

const routes: Array<RouteConfig> = [
  {
    path: '/',
    meta: { layout: 'HomeLayout' },
    component: () => import(/* webpackChunkName: "home" */ '@/view/home/xdb.vue')
  },
  {
    path: '/oa',
    meta: { layout: 'HomeLayout' },
    component: () => import(/* webpackChunkName: "home" */ '@/view/home/oa.vue')
  },
  {
    path: '/passport',
    meta: { layout: 'HomeLayout' },
    component: () => import(/* webpackChunkName: "home" */ '@/view/home/passport.vue')
  },
  ...ruan_route,
  ...ruan_route_detail,
  ...hundun_route,
  ...limit_route
];
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});
const setLogin = async function (data: any) {
  storage.setItem('profile', data, EXPIRED as any);

  // 登录旧版 OA
  await client.get(`${OA}/index.php/Admin/Login/Session`);
  // 登录旧版 XDB
  await client.get(`${XDB}/passport/login/session`);
};

// 检验登录状态
router.beforeEach(async (to, from, next) => {
  console.info(process.env);
  const profile = storage.getItem('profile');
  const is_online = !!profile;
  const menu_data = [];

  console.log('STAGE', STAGE);

  if (STAGE !== 'master') {
    if (!is_online) {
      setLogin({
        uid: 2850,
        account: 'shenzhijian',
        groups: ['1', '2'],
        rules: [
          '1',
          '10',
          '100',
          '101',
          '102',
          '103',
          '104',
          '105',
          '106',
          '107',
          '108',
          '109',
          '11',
          '110',
          '111',
          '112',
          '113',
          '114',
          '115',
          '116',
          '117',
          '118',
          '119',
          '12',
          '120',
          '121',
          '125',
          '126',
          '127',
          '128',
          '129',
          '13',
          '130',
          '131',
          '132',
          '133',
          '134',
          '135',
          '137',
          '138',
          '139',
          '14',
          '140',
          '143',
          '144',
          '145',
          '146',
          '147',
          '148',
          '149',
          '15',
          '150',
          '151',
          '152',
          '153',
          '154',
          '155',
          '156',
          '157',
          '158',
          '159',
          '16',
          '160',
          '161',
          '163',
          '164',
          '165',
          '166',
          '167',
          '168',
          '169',
          '17',
          '170',
          '171',
          '172',
          '173',
          '174',
          '175',
          '176',
          '177',
          '178',
          '179',
          '18',
          '180',
          '181',
          '182',
          '183',
          '184',
          '185',
          '186',
          '187',
          '188',
          '189',
          '19',
          '190',
          '191',
          '192',
          '193',
          '194',
          '195',
          '196',
          '197',
          '198',
          '199',
          '2',
          '20',
          '200',
          '201',
          '202',
          '203',
          '204',
          '205',
          '206',
          '207',
          '208',
          '209',
          '21',
          '210',
          '211',
          '212',
          '214',
          '216',
          '217',
          '218',
          '219',
          '22',
          '220',
          '221',
          '222',
          '223',
          '224',
          '225',
          '226',
          '227',
          '228',
          '229',
          '23',
          '230',
          '231',
          '232',
          '233',
          '234',
          '235',
          '236',
          '237',
          '238',
          '239',
          '24',
          '240',
          '241',
          '242',
          '243',
          '244',
          '245',
          '246',
          '247',
          '248',
          '249',
          '25',
          '250',
          '251',
          '252',
          '253',
          '254',
          '255',
          '256',
          '257',
          '258',
          '259',
          '26',
          '260',
          '262',
          '263',
          '264',
          '265',
          '266',
          '267',
          '268',
          '269',
          '27',
          '270',
          '272',
          '274',
          '275',
          '276',
          '277',
          '278',
          '279',
          '28',
          '280',
          '281',
          '282',
          '283',
          '286',
          '288',
          '289',
          '29',
          '290',
          '291',
          '292',
          '294',
          '295',
          '296',
          '297',
          '298',
          '299',
          '3',
          '30',
          '300',
          '302',
          '31',
          '32',
          '33',
          '34',
          '35',
          '36',
          '37',
          '38',
          '39',
          '4',
          '40',
          '41',
          '42',
          '43',
          '44',
          '45',
          '46',
          '47',
          '48',
          '49',
          '5',
          '50',
          '51',
          '52',
          '53',
          '54',
          '55',
          '56',
          '57',
          '58',
          '59',
          '6',
          '60',
          '61',
          '62',
          '63',
          '64',
          '65',
          '66',
          '67',
          '68',
          '69',
          '7',
          '70',
          '71',
          '72',
          '73',
          '74',
          '75',
          '76',
          '77',
          '78',
          '79',
          '8',
          '80',
          '81',
          '82',
          '83',
          '84',
          '85',
          '86',
          '87',
          '89',
          '9',
          '90',
          '91',
          '92',
          '93',
          '94',
          '95',
          '96',
          '97',
          '98',
          '99'
        ],
        rules_xdb: [
          '10000',
          '10001',
          '10002',
          '10003',
          '10011',
          '10012',
          '10013',
          '10014',
          '10015',
          '10032',
          '10033',
          '10034',
          '10035',
          '10036',
          '10037',
          '10038',
          '10039',
          '10040',
          '10041',
          '10042',
          '10043',
          '10044',
          '10045',
          '10046',
          '10047',
          '10048',
          '10178',
          '10179',
          '10180',
          '10181',
          '10182',
          '10183',
          '10184',
          '10245',
          '10246',
          '10247',
          '10240',
          '10241',
          '10261',
          '10262',
          '10263',
          '10242',
          '10284',
          '10243',
          '10244',
          '10307',
          '10308',
          '10394',
          '10395',
          '10396',
          '10397',
          '10254',
          '10255',
          '10256',
          '10257',
          '10258',
          '10339',
          '10340',
          '10344',
          '10345',
          '10366',
          '10341',
          '10346',
          '10347',
          '10367',
          '10342',
          '10348',
          '10349',
          '10368',
          '10343',
          '10350',
          '10351'
        ],
        name: '测试',
        avatar: ''
      });
    }
    next();
    return null;
  }

  if (to.path.includes('hundun') && is_online) {
    if (!(window as any).route_menu_obj) {
      const { data }: any = await client.get(`${API.product_menu}?product_code=hundun`);
      (window as any).route_menu_obj = data.menu_list;
    }
    if ((window as any).route_menu_obj) {
      const filter_data = (window as any).route_menu_obj.filter((item: any) => {
        if (to && to.meta) {
          return to.meta.from ? to.meta.from.includes(item.rule) && item.rule : to.path.includes(item.rule) && item.rule;
        }
        return null;
      });
      if (filter_data.length) {
        (window as any).route_menu_id = filter_data[0].id;
      }
    }
  }

  if (!is_online && to.path != '/passport' && !to.query.code) {
    const res = await client.get(`${FCAPI}/boss/setting/passport`);
    console.debug('passport:', res);
    if (res.status === 200) {
      setLogin(res.data);
      next('/');
    } else {
      next('/passport');
    }
  }

  if (to.query.code) {
    const res = await client.post(`${FCAPI}/boss/setting/passport`, {
      code: to.query.code,
      type: to.query.type
    });

    if (res.status !== 200) {
      console.error(res);
      next('/passport');
    }

    setLogin(res.data);

    next('/');
  }
  next();
});

export { router, ruan_route, hundun_route, limit_route };
